import BaseService from 'services/BaseService';


const apiName = 'TenantManagementServiceAPI';
const collectionPath = '/tenants';

export const fetchRecords = (query) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.fetchRecords(query);
};

export const fetch = (id) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.fetch(id);
};

export const add = (payload) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.add(payload);
};

export const update = (id, payload) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.update(id, payload);
};

export const deleteRecord = (id) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.deleteRecord(id);
};

export const fetchUserWithLocation = async (location) => {
    const baseService = new BaseService(apiName, collectionPath);
    let path = location;
    let options = {};
    return await baseService.makeGetApiCall(apiName, path, options);
};

export const updateTermsAndConditions = (id) => {
    const baseService = new BaseService(apiName, collectionPath);
    const payload = {'tc-accepted': true};
    return baseService.patch(id, payload);
};

export const fetchApplications = async (customerId, query, callback) => {
    const baseService = new BaseService(apiName, collectionPath);

    let path = '/tenant/' + customerId + '/app';

    let headers = {};

    let queryStringParameters = {offset: 0, limit: 100};
    // overwrite
    queryStringParameters = query;

    let options = {
        headers: headers,
        queryStringParameters: queryStringParameters,
    };

    baseService.makeGetApiCall(apiName, path, options).then(callback);
};
